// bootstrap 4
import 'bootstrap'

// jquery
import 'jquery/dist/jquery'
import './extension/JQueryPrivateExtension'

// jquery-ui
import 'jquery-ui-dist/jquery-ui.min'

// jquery-validation
import 'jquery-validation/dist/jquery.validate.min'
import 'jquery-validation/dist/additional-methods.min'
import './localization/validation_messages'

// jquery-datatables.net
import 'datatables.net'
import 'datatables.net-jqui'

// jquery-datatables.net-responsive
import 'datatables.net-responsive'
import 'datatables.net-responsive-jqui'
import './localization/datatables_messages'

// blueimp-file-upload
import 'blueimp-file-upload/js/vendor/jquery.ui.widget'
import 'blueimp-file-upload/js/jquery.iframe-transport'
import 'blueimp-file-upload/js/jquery.fileupload'
import 'blueimp-file-upload/js/jquery.fileupload-process'
import 'blueimp-file-upload/js/jquery.fileupload-ui'
import './localization/fileupload_messages'

// bootstrap-datepicker
import 'bootstrap-datepicker/dist/js/bootstrap-datepicker.min'
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.ja.min'
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.zh-CN.min'
import './localization/datepicker_messages'

// application
import './localization/ApplicationMessages'

// chart.js
import 'chart.js'